var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowPagination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41.17a.58.58 0 010 .821L1.402 6l5.008 5.009a.58.58 0 11-.82.82L.17 6.412a.58.58 0 010-.822L5.59.17a.58.58 0 01.82 0z",
    fill: "#1A1A1A"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDcgMTIiIGZpbGw9Im5vbmUiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjQxMDUgMC4xNzAwNjdDNi42MzcyNiAwLjM5NjgyMyA2LjYzNzI2IDAuNzY0NDY3IDYuNDEwNSAwLjk5MTIyM0wxLjQwMTcyIDZMNi40MTA1IDExLjAwODhDNi42MzcyNSAxMS4yMzU1IDYuNjM3MjUgMTEuNjAzMiA2LjQxMDUgMTEuODI5OUM2LjE4Mzc0IDEyLjA1NjcgNS44MTYxIDEyLjA1NjcgNS41ODkzNCAxMS44Mjk5TDAuMTY5OTg4IDYuNDEwNThDLTAuMDU2NzY3MyA2LjE4MzgyIC0wLjA1Njc2NzIgNS44MTYxOCAwLjE2OTk4OCA1LjU4OTQyTDUuNTg5MzQgMC4xNzAwNjdDNS44MTYxIC0wLjA1NjY4OSA2LjE4Mzc0IC0wLjA1NjY4OSA2LjQxMDUgMC4xNzAwNjdaIiBmaWxsPSIjMUExQTFBIi8+Cjwvc3ZnPgo=";
export { SvgArrowPagination as ReactComponent };